export * from './lib/UiKitLabelBrand';
